/** Plain text for JSON-LD; regex so it works during SSG (no DOM). */
export const stripHtmlForSchema = (html: string | null | undefined): string => {
  if (!html) return ''
  return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
}

export type FaqSchemaItem = {
  question?: string | null
  answer?: string | null
}

export type FaqPageJsonLd = {
  '@context': 'https://schema.org'
  '@type': 'FAQPage'
  mainEntity: Array<{
    '@type': 'Question'
    name: string
    acceptedAnswer: { '@type': 'Answer'; text: string }
  }>
}

export const buildFaqPageJsonLd = (
  items:
    | readonly (FaqSchemaItem | null | undefined)[]
    | null
    | undefined,
): FaqPageJsonLd | null => {
  const mainEntity =
    items?.reduce<
      Array<{
        '@type': 'Question'
        name: string
        acceptedAnswer: { '@type': 'Answer'; text: string }
      }>
    >((acc, faq) => {
      const name = faq?.question?.trim() ?? ''
      const text = stripHtmlForSchema(faq?.answer ?? '')
      if (!name || !text) return acc
      acc.push({
        '@type': 'Question',
        name,
        acceptedAnswer: {
          '@type': 'Answer',
          text,
        },
      })
      return acc
    }, []) ?? []

  if (mainEntity.length === 0) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  }
}
